import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { LoadingScreen } from "../components/feedback/LoadingScreen";

/**
 * Protects the authenticated area (Phase 5.8). While the current-user query is
 * loading, shows a spinner. When there is no user, redirects to /login
 * preserving the intended path and, when relevant, marks the redirect as a
 * session expiry. In development mode /me always returns a user, so this is a
 * transparent pass-through there.
 */
export function RequireAuth({ children }: { children: ReactNode }): JSX.Element {
  const { user, isLoading, sessionExpired } = useAuth();
  const location = useLocation();

  if (isLoading) return <LoadingScreen message="Loading Copilot…" />;
  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname, sessionExpired: Boolean(sessionExpired) }}
      />
    );
  }
  return <>{children}</>;
}
